import apiClient from "./axios"

// ============================
// 🔹 Quotation API Services
// ============================

// Get all quotations (paginated or filtered)
export const getQuotations = async (params = {}) => {
  const { data } = await apiClient.get("/quotations", { params })
  return data
}

// Get a specific quotation by ID
export const getQuotation = async id => {
  const { data } = await apiClient.get(`/quotations/${id}`)
  return data
}

// Create a new quotation
export const createQuotation = async quotationData => {
  const { data } = await apiClient.post("/quotations", quotationData)
  return data
}

// Update an existing quotation
export const editQuotation = async ({ id, ...quotationData }) => {
  const { data } = await apiClient.patch(`/quotations/${id}`, quotationData)
  return data
}

// Soft delete a quotation
export const deleteQuotation = async id => {
  const { data } = await apiClient.delete(`/quotations/${id}`)
  return data
}

// Get all quotations without pagination
export const getAllQuotations = async (params = {}) => {
  const { data } = await apiClient.get("/quotations", {
    params: { ...params, all: true },
  })
  return data
}

// Search quotations by QID, customer, or vehicle
export const searchQuotations = async (searchTerm, params = {}) => {
  const { data } = await apiClient.get("/quotations", {
    params: { ...params, search: searchTerm },
  })
  return data
}

// Get trashed quotations
export const getTrashedQuotations = async (params = {}) => {
  const { data } = await apiClient.get("/quotations/trashed", { params })
  return data
}

// Restore a trashed quotation
export const restoreQuotation = async id => {
  const { data } = await apiClient.post(`/quotations/${id}/restore`)
  return data
}

// Permanently delete a quotation
export const forceDeleteQuotation = async id => {
  const { data } = await apiClient.delete(`/quotations/${id}/force-delete`)
  return data
}
